export const browser = (() => {
  try {
    return typeof window !== "undefined";
  } catch (e) {
    return false;
  }
})();

export const hasHistoryEntries = browser && window.history.length > 1;

export const iframed =
  browser &&
  (() => {
    try {
      return window.top !== window.self;
    } catch (e) {
      return false;
    }
  })();

export const isIOS =
  browser &&
  (function iOS() {
    const navigator = window.navigator;
    return (
      ["iPad", "iPhone"].some(
        (platform) => navigator && navigator.platform.includes(platform)
      ) ||
      (navigator &&
        navigator.userAgent.includes("Mac") &&
        "ontouchend" in document)
    );
  })();

export const iOSSafariStandalone =
  browser && "standalone" in window.navigator && window.navigator.standalone;

export const isDesktopSafari =
  browser &&
  (function desktopSafari() {
    const v = navigator.appVersion;
    return (
      v.indexOf("Safari") !== -1 &&
      v.indexOf("Mobile") === -1 &&
      v.indexOf("Chrome") === -1
    );
  })();

export const isMobileSafari =
  browser &&
  (function mobileSafari() {
    const v = navigator.appVersion;
    return (
      v.indexOf("Safari") !== -1 &&
      v.indexOf("Mobile") !== -1 &&
      v.indexOf("iPhone") !== -1
    );
  })();

export const isSafari = isMobileSafari || isDesktopSafari;

export const supportsEnhancedExperience =
  browser && typeof window.self.Reflect !== "undefined";

export const supportsVoice = supportsEnhancedExperience && !iOSSafariStandalone;

export const supportsNativeHls =
  browser &&
  !isDesktopSafari &&
  (() => {
    const video = document.createElement("video");
    return video.canPlayType("application/vnd.apple.mpegurl");
  })();
